var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarksPreviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 291,
    height: 166,
    viewBox: "0 0 291 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmarks_-_Preview_image_1",
    "data-name": "Bookmarks - Preview image 1",
    transform: "translate(-847 -566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5557",
    "data-name": "Rectangle 5557",
    width: 291,
    height: 166,
    rx: 14,
    transform: "translate(847 566)",
    fill: "#a2cdff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65395",
    "data-name": "Group 65395",
    transform: "translate(30 38)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "No_preview_available",
    "data-name": "No preview available",
    transform: "translate(889 636)",
    fontSize: 16,
    fontFamily: "Geist, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "No preview available")), /*#__PURE__*/React.createElement("g", {
    id: "Group_65765",
    "data-name": "Group 65765",
    transform: "translate(-1963.719 -6422.719)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(2910.719 7006.719)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bookmarks_filled_icon",
    "data-name": "Bookmarks filled icon",
    transform: "translate(2919.18 7015.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5324",
    "data-name": "Rectangle 5324",
    width: 17,
    height: 17,
    transform: "translate(-0.461 -0.461)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bookmarks-fill-svgrepo-com",
    transform: "translate(1.651 0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34314",
    "data-name": "Path 34314",
    d: "M15.4,1H8.393A1.4,1.4,0,0,0,7,2.4h7a1.4,1.4,0,0,1,1.4,1.4v9.105l1.4.7V2.4A1.4,1.4,0,0,0,15.4,1Z",
    transform: "translate(-4.198 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34315",
    "data-name": "Path 34315",
    d: "M4.4,5h7a1.4,1.4,0,0,1,1.4,1.4V17.606l-4.9-2.1L3,17.606V6.4A1.4,1.4,0,0,1,4.4,5Z",
    transform: "translate(-3 -2.198)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksPreviews);
export default __webpack_public_path__ + "static/media/bookmarksPreviews.9a7ba1a4f067bb563fec5f700f231371.svg";
export { ForwardRef as ReactComponent };